'use client';

import { useEffect, useState } from 'react';
import ReviewCarousel from './ReviewCarousel';

interface Review {
  id: string;
  guest: string;
  property: string;
  rating: number;
  text: string;
  date: string;
}

export interface ReviewCarouselLabels {
  eyebrow?: string;
  title?: string;
  translatingLabel?: string;
  translatedLabel?: string;
  funDividerLabel?: string;
  prevLabel?: string;
  nextLabel?: string;
  gotoTemplate?: string;
}

export default function ReviewCarouselLoader({
  eyebrow = 'Guest Reviews',
  title = 'What Our Guests Say',
  translatingLabel,
  translatedLabel,
  funDividerLabel,
  prevLabel,
  nextLabel,
  gotoTemplate,
}: ReviewCarouselLabels) {
  const [reviews, setReviews] = useState<Review[] | null>(null);

  useEffect(() => {
    fetch('/api/reviews')
      .then((r) => r.json())
      .then((data) => {
        const fiveStars = data
          .filter((r: Review) => r.rating === 5)
          .slice(0, 20);
        setReviews(fiveStars);
      })
      .catch(() => {});
  }, []);

  if (!reviews) {
    return (
      <section className="py-20 px-6 bg-[#F0EDE5]">
        <div className="max-w-4xl mx-auto text-center">
          <p className="font-sans text-xs font-medium uppercase tracking-[0.25em] mb-3 text-[#5A5A6E]">
            {eyebrow}
          </p>
          <h2 className="font-sans text-3xl md:text-4xl font-light text-[#1A1A2E] mb-8">
            {title}
          </h2>
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-lg shadow-slate-200/40">
            <div className="h-32 flex items-center justify-center">
              <div className="h-4 w-64 bg-[#F0EDE5] rounded animate-pulse" />
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <ReviewCarousel
      reviews={reviews}
      eyebrow={eyebrow}
      title={title}
      translatingLabel={translatingLabel}
      translatedLabel={translatedLabel}
      funDividerLabel={funDividerLabel}
      prevLabel={prevLabel}
      nextLabel={nextLabel}
      gotoTemplate={gotoTemplate}
    />
  );
}
